import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-dark uppercase py-2 pl-6 text-light3" }

import { computed, onMounted, onUnmounted } from "vue";
import UpcomingReservation from "./UpcomingReservation.vue";
import { UpcomingItem } from "./upcoming";
import { getTimeDiff, getMsTillMidnight, getNumberOfMinutes } from "@/helpers/Time";
import { useScheduleStore } from "@/store/Schedule";
import { addMilliseconds } from "date-fns";
import { watch } from "vue";
import { useWindowSize } from "@/composables/windowSize";
import { MODE } from "@/types/Schedule";
import { Reservation } from "@/types/Reservation";
import { useProfileStore } from "@/store/Profile";
import { useI18n } from "vue-i18n";

interface Props {
  upcomingList: Reservation[];
}

interface Emits {
  (e: "closeUpcoming"): void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    upcomingList: null
  },
  emits: ["closeUpcoming"],
  setup(__props: any, { emit }: { emit: ({
  (e: "closeUpcoming"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  upcomingList: Reservation[];
}

let closeTimer: ReturnType<typeof setTimeout> | null = null;


const scheduleStore = useScheduleStore();
const profileStore = useProfileStore();
const timeout = 30 * 1000;

const { height } = useWindowSize();
const { t } = useI18n();

onMounted(() => {
  closeTimer = setTimeout(() => {
    emit("closeUpcoming");
  }, timeout);
});

onUnmounted(() => {
  if (closeTimer) {
    clearTimeout(closeTimer);
  }
});

const updateTimeout = () => {
  if (closeTimer) {
    clearTimeout(closeTimer);
  }
  closeTimer = setTimeout(() => {
    emit("closeUpcoming");
  }, timeout);
};

const reservationsCount = computed(() => displayList.value.length);

const isAvailable = computed(() => profileStore.isAvailable(scheduleStore.getTime));

const displayList = computed(() => {
  const list: UpcomingItem[] = [];
  const nearestReservation = scheduleStore.firstFutureReservation;

  props.upcomingList.forEach((item, idx) => {
    const { title, startTime, endTime, pending } = item;

    const prev = props.upcomingList[idx - 1];

    if (prev && getNumberOfMinutes(getTimeDiff(item.startTime, prev.endTime)) > 5 && isAvailable.value) {
      list.push({
        title: t("upcomingListAvailable"),
        startTime: prev.endTime,
        endTime: item.startTime,
        emptySlot: true,
      });
    }

    list.push({ title, startTime: startTime, endTime: endTime, pending });
  });

  // Add available slot as first one
  if (
    list[0] &&
    nearestReservation &&
    getNumberOfMinutes(getTimeDiff(props.upcomingList[0].startTime, nearestReservation.endTime)) > 5 &&
    scheduleStore.getScreenMode !== MODE.AVAILABLE &&
    isAvailable.value
  ) {
    list.unshift({
      title: t("upcomingListAvailable"),
      startTime: nearestReservation.endTime,
      endTime: props.upcomingList[0].startTime,
      emptySlot: true,
    });
  }

  // Add available slot at the end
  const lastEvent = props.upcomingList[props.upcomingList.length - 1];
  if (lastEvent && getNumberOfMinutes(lastEvent.endTime.getTime()) > 0 && isAvailable.value) {
    list.push({
      title: t("upcomingListAvailable"),
      startTime: lastEvent.endTime,
      endTime: addMilliseconds(lastEvent.endTime, getMsTillMidnight(lastEvent.endTime.getTime())),
      emptySlot: true,
      isLast: true,
    });
  }

  return list;
});

watch(reservationsCount, () => {
  if (reservationsCount.value < 1) {
    emit("closeUpcoming");
  }
});

return (_ctx: any,_cache: any) => {
  return (_unref(displayList).length > 0)
    ? (_openBlock(), _createElementBlock("aside", {
        key: 0,
        class: "w-72 bg-upcoming absolute overflow-y-scroll overflow-x-hidden top-0 right-0",
        style: _normalizeStyle({ height: _unref(height) + 'px' }),
        onTouchstart: updateTimeout
      }, [
        _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t("upcomingListUpcoming")), 1),
        _createVNode(_TransitionGroup, {
          name: "reservation",
          tag: "ul",
          class: "flex flex-col py-4 px-2"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayList), (item, idx) => {
              return (_openBlock(), _createBlock(UpcomingReservation, {
                key: idx,
                item: item
              }, null, 8, ["item"]))
            }), 128))
          ]),
          _: 1
        })
      ], 36))
    : _createCommentVNode("", true)
}
}

})